module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parent"
  }, [_c('div', {
    staticClass: "head"
  }), _vm._v(" "), _c('div', {
    staticClass: "mid"
  }, [_c('div', {
    staticClass: "time",
    domProps: {
      "textContent": _vm._s(_vm.obj.created_at)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contents",
    domProps: {
      "textContent": _vm._s(_vm.obj.message)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "foot"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d687580"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VMyNew.vue
// module id = 757
// module chunks = 1